<template lang="pug">
div
  cp-header(:partner="hasPartnerA2G")
  component(v-bind:is="component")
  cb-footer(
    v-if="!hasPartnerA2G"
    product="trip"
    :hideLinks="showLivelo ? [] : ['pontos-livelo']"
    INSTITUCIONAL_URL="https://www.ciclic.com.br"
  )
</template>

<script>
import cpHeader from '@/components/ui/Header.vue'
import InstantPaymentsIndex from '@/components/views/success/instantPayment'
import NonInstantPaymentsIndex from '@/components/views/success/nonInstantPayment'
import { mapGetters } from 'vuex'

export default {
  name: 'Success',
  components: {
    cpHeader,
    NonInstantPaymentsIndex,
    InstantPaymentsIndex
  },
  created () {
    // Verifica se existe um planUuid antes de disparar os eventos de métricas,
    // se não tiver, retornar para página alterior
    if (this.planUuid) {
      window.dataLayer.push({
        event: 'gaevent',
        gaEventCategory: 'Contratação',
        gaEventAction: '1.1.CompraRealizada',
        gaEventLabel: 'CompraRealizada'
      })

      // DataLayer para Retargeting
      window.dataLayer.push({
        event: 'afiliattionTag',
        level: 'checkoutPage',
        transactionID: this.planUuid,
        price: this.valueByPerson,
        quantity: this.totalNumberOfPassengers,
        transactionTotal: this.selectedQuote.totalValue
      })

      if (process.env.NODE_ENV !== 'development') {
        window.sessionStorage.removeItem('ciclic:travel:lead')
        window.sessionStorage.removeItem('ciclic:product')
        window.sessionStorage.removeItem('ciclic:checkout')
      }
    }
  },
  computed: {
    ...mapGetters('quotation', ['showLivelo']),
    hasPartnerA2G () {
      return this.theme === 'a2g'
    },
    component () {
      const isInstantUndefined = typeof this.$store.state.payment.isInstant === 'undefined'
      return isInstantUndefined || this.$store.state.payment.isInstant ? 'InstantPaymentsIndex' : 'NonInstantPaymentsIndex'
    }
  }
}
</script>
